import Vue from 'vue';
import Pagination from '@global/components/global/Pagination';
import Slick from '@global/vendors/vue-slick.vue';
import SortApp from '@page/productListStatic/components/SortApp.vue';
import GridMode from '@page/productListStatic/components/GridMode.vue';
import Recommend from '@page/productListStatic/components/Recommend.vue';
import $ from 'jquery';
import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import store from '@global/components/store/index';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';

function RenderProductListContent() {
  const shop = new Vue({
    el: '#app-shop',
    store,
    components: {
      GridMode,
      SortApp,
      Recommend,
    },
    data: {
      largeMode: false,
      sortConditionDatas: null,
      sortConditionIsLoad: false,
      bannerSliderConfig: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 6000,
      },
    },
    created() {
      this.getSortCondition();
    },
    mounted() {
      if ($('.banner-slide').length) {
        $('.banner-slide').slick(this.bannerSliderConfig);
      }
    },
    methods: {
      swichGridMode(lMode) {
        this.largeMode = lMode;
      },
      getSortCondition() {
        const that = this;

        $.ajax({
          type: 'GET',
          url: API_URL.SORT_POPUP,
          dataType: 'json',
          xhrFields: {
            withCredentials: true,
          },
          error() {
            console.log('error');
          },
          success(res) {
            if (res.Code === 200) {
              that.sortConditionDatas = res.Response;
              that.sortConditionIsLoad = true;
            }
          },
        });
      },
      fireGTM(customMarketID, size) {
        fireShopListClickGTMEvent({ customMarketID, size });
      },
    },
  });

  const pagination = new Vue({
    el: '#pagination',
    components: { Pagination },
    template: '<Pagination></Pagination>',
  });

  if (!window.location.pathname.includes('search')) {
    fireShopListViewEvent();
  }
}

export default RenderProductListContent;
